import * as React from "react";
import { ShiftCheckbox, type ShiftCheckboxChangeMeta } from "@/components/ui/shift-checkbox";

interface Props {
  checked: boolean;
  onCheckedChange: (checked: boolean, meta: SnapshotCheckboxChangeMeta) => void;
  ariaLabel?: string;
  disabled?: boolean;
  onClick?: (e: React.MouseEvent) => void;
}

export type SnapshotCheckboxChangeMeta = ShiftCheckboxChangeMeta;

export const SnapshotCheckbox: React.FC<Props> = ({
  checked,
  onCheckedChange,
  ariaLabel,
  disabled = false,
  onClick,
}) => (
  <ShiftCheckbox
    checked={checked}
    onCheckedChange={onCheckedChange}
    aria-label={ariaLabel}
    disabled={disabled}
    onClick={onClick}
    className="data-[state=checked]:border-blue-600 data-[state=checked]:bg-blue-600"
  />
);
